import { Component } from 'react';

export default class Notifier extends Component {
    displayed = [];

    storeDisplayed = id => {
        this.displayed = [...this.displayed, id];
    };

    shouldComponentUpdate({ notifications: newSnacks = [] }) {
        let notExists = false;

        for (let i = 0; i < newSnacks.length; i++) {
            if (notExists) {
                continue;
            }

            notExists = notExists ||
                !this.props.notifications.filter((notification) => newSnacks[i].key === notification.key).length;
        }

        return notExists;
    }

    componentDidUpdate() {
        const { notifications = [] } = this.props;

        notifications.forEach(notification => {

            // Do nothing if snackbar is already displayed
            if (this.displayed.includes(notification.key)) {
                return;
            }

            // Display snackbar
            this.props.enqueueSnackbar(this.props.t(notification.message), notification.options);

            // Keep track of snackbars that we've displayed
            this.storeDisplayed(notification.key);

            // Dispatch action to remove snackbar from store
            this.props.removeSnackbar(notification.key);
        });
    }

    render() {
        return null;
    }
}
